























import {
    Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
// @Component 修饰符表明此类为一个 Vue 组件 组件必须加
@Component({})
export default class Sider extends Vue {
//    设置修饰符避免还没有给 初始化
   @Prop()
    sideData!: Array<Object>;

    private activeBar: Array<Object> = [];

    private listCls: Object = {};

    private sideBarMenu: Array<Object> = [];

    private hideSide: Boolean = false;

    toogle(e: any) {
        this.sideBarMenu[e] = !this.sideBarMenu[e];
        this.initCls();
    }

    checkChild(data: any) {
        const self = this;
        data.forEach((d:any) => {
            if (Object.keys(d).indexOf('children') !== -1) {
                self.sideBarMenu[d.name] = false;
                self.activeBar[d.name] = false;
                self.checkChild(d.children);
            }
        });
    }

    initCls() {
        const result:any = {};
        Object.keys(this.sideBarMenu).forEach((d:any) => {
            result[d] = [
                'side-menu',
                {
                    'side-hide': !this.sideBarMenu[d],
                    'side-show': this.sideBarMenu[d],
                    'small-show': this.sideBarMenu[d] && this.hideSide,
                },
            ];
        });
        this.listCls = result;
    }

    showTab() {
        const target = this.$route.path ? this.$route.path.split('/') : [];
        target.forEach((d:any) => {
            if (d && this.activeBar[d] !== 'undefined') {
                this.sideBarMenu[d] = true;
                this.activeBar[d] = true;
                this.initCls();
            }
        });
    }

    // 初始化设置侧边栏
    created() {
        this.checkChild(this.sideData);
        this.showTab();
        this.initCls();
    }

    @Watch('$route')
    onRouteChange() {
        Object.keys(this.activeBar).forEach((d:any) => {
            this.activeBar[d] = false;
        });
        this.showTab();
    }
}
